// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1NotFoundErrorSchema } from './v1/notFoundErrorSchema';
import { v1ProjectSchema } from './v1/projectSchema';
import { v1ProjectsUpdateSchema } from './v1/projects/updateSchema';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';
import { v1ValidationErrorSchema } from './v1/validationErrorSchema';

export const updateProjectPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
  id: z.number().int().describe("Project ID"),
});

export const updateProjectHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Project updated
 */
export const updateProject200Schema = z.lazy(() => v1ProjectSchema);

/**
 * @description Unauthorized
 */
export const updateProject401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

/**
 * @description Project not found
 */
export const updateProject404Schema = z.lazy(() => v1NotFoundErrorSchema);

/**
 * @description Validation errors
 */
export const updateProject422Schema = z.lazy(() => v1ValidationErrorSchema);

export const updateProjectMutationRequestSchema = z.lazy(() => v1ProjectsUpdateSchema);

export const updateProjectMutationResponseSchema = z.lazy(() => updateProject200Schema);
